import _ from 'underscore';

export const ExpandedTextAd = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Expanded Text Ad',
    },
    TextPart2: {
      'bulk-upload-header': 'Text Part 2',
    },
    TitlePart1: {
      'bulk-upload-header': 'Title Part 1',
    },
    TitlePart2: {
      'bulk-upload-header': 'Title Part 2',
    },
    TitlePart3: {
      'bulk-upload-header': 'Title Part 3',
    },
    Path1: {
      'bulk-upload-header': 'Path 1',
    },
    Path2: {
      'bulk-upload-header': 'Path 2',
    },
    DisplayUrl: {
      'bulk-upload-header': 'Domain',
    },
    FinalUrls: {
      'bulk-upload-header': 'Final Url',
      'bulk-upload-mapper': function (value) {
        return value.join('; ');
      },
    },
    MobileFinalUrls: {
      'bulk-upload-header': 'Mobile Final Url',
      'bulk-upload-mapper': function (value) {
        return value.join('; ');
      },
    },
    TrackingUrlTemplate: {
      'bulk-upload-header': 'Tracking Template',
    },
    FinalUrlSuffix: {
      'bulk-upload-header': 'Final Url Suffix',
    },
    UrlCustomParameters: {
      'bulk-upload-header': 'Custom Parameter',
      'bulk-upload-mapper': function (value) {
        return _.map(value, p => `{_${p.Key}}=${p.Value}`).join('; ');
      },
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    AdGroupName: {
      'bulk-upload-header': 'Ad Group',
    },
    NativePreference: {
      'bulk-upload-header': 'Ad Format Preference',
      'bulk-upload-mapper': function (value) {
        const mapping = {
          None: 'All',
          NativePreference: 'Native',
        };

        return mapping[value];
      },
    },
  },
};
